let notified = false

export function notifyLoaded() {
  if (notified) {
    return
  }
  notified = true
  if (window.Android) {
    window.Android.onLoaded()
  }

  if (window.webkit?.messageHandlers) {
    window.webkit.messageHandlers.youchatMessageHandler.postMessage('loaded')
  }
}
